import React from "react";

const JobCard = ({ jobs }) => {
  return (
    <div className="font-sans">
      {/* Job Table */}
      <div className="bg-white px-6 py-8 overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="text-sm text-gray-600 border-b">
              <th className="pb-2">Job Title</th>
              <th className="pb-2">Job Created Date</th>
              <th className="pb-2">Location</th>
              <th className="pb-2">Job Id</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr
                key={job.id}
                onClick={() =>
                  (window.location.href = `/glowtech-careers/${job.id}`)
                }
                className="text-sm border-t hover:bg-gray-100 cursor-pointer"
              >
                <td className="py-2 text-blue-600 hover:underline">
                  {job.title}
                </td>
                <td className="py-2 text-gray-700">📅 {job.createdDate}</td>
                <td className="py-2 text-gray-700">📍 {job.location}</td>
                <td className="py-2 text-gray-700">📝 {job.jobId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-indigo-900 to-blue-500 text-white px-6 py-12 text-center mt-12">
        <h2 className="text-2xl font-semibold mb-2">
          Don’t see your next job?
        </h2>
        <p className="mb-6">
          Submit your resume anyways and we'll let you know when we find the
          perfect job for you.
        </p> 
        <a href="mailto:hr@glowtechsolutions.in" >
          📩 <span className="underline font-bold">hr@glowtechsolutions.in</span>
        </a>
      </div>
    </div>
  );
};

export default JobCard;
